import { AutomationDialog } from '../../Automations/AutomationDialog';
import useAutomationApiPerType from '../../Automations/useAutomationApiPerType';
import { MultipleRuleBuildersProvider } from '../../common/sweep-condition-rule-builder/MultipleRuleBuildersContext';
import { useAutomationsContext } from '../../Automations/AutomationsContext';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';

export const ConfigurationCanvasAutomationsPanel = ({
  automations,
  onClose,
  disableCanvasTemplates,
}: {
  automations?: AutomationStructureNew[];
  onClose?: () => void;
  disableCanvasTemplates?: boolean;
}) => {
  const { automationVariant } = useAutomationsContext();
  const currentCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant });

  return (
    <MultipleRuleBuildersProvider>
      <AutomationDialog
        isLoading={!automations}
        onSaveOrCreate={onSaveOrCreate}
        onToggleActivation={onToggleActivation}
        automations={automations ?? []}
        crmOrgId={currentCrmOrgId ?? ''}
        onDeleteAutomation={onDeleteAutomation}
        automationVariant={automationVariant}
        onDeployAutomation={onDeployAutomation}
        onClose={onClose}
        disableCanvasTemplates={disableCanvasTemplates}
        key={currentCrmOrgId} // force re-render when the current crm org changes
      />
    </MultipleRuleBuildersProvider>
  );
};
